import { render, staticRenderFns } from "./substopselling.vue?vue&type=template&id=5f0b73d2&scoped=true"
import script from "./substopselling.vue?vue&type=script&lang=js"
export * from "./substopselling.vue?vue&type=script&lang=js"
import style0 from "./substopselling.vue?vue&type=style&index=0&id=5f0b73d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b73d2",
  null
  
)

export default component.exports